//fetch関数は引数に取得するデータのパスやURLを指定
//関数作成
export const getAllPokemon = (url) => {
  return new Promise((resolve, reject) => {
    fetch(url)  //データを取得
      .then((res) => res.json())  //JSON形式で返す
      .then((data) => resolve(data))  //dataを受け取り、JSON形式のデータを最終的に返す
  });
};

export const getPokemon = (url) => {
  return new Promise((resolve, reject) => {
    fetch(url)  //データを取得
      .then((res) => res.json())  //JSON形式で返す
      .then((data) => {
        // console.log(data);
        resolve(data)
      })  //dataを受け取り、JSON形式のデータを最終的に返す
  });
};
